export interface IChronoCompleteRequest {
  caseLineItemId: number
  chronoCompleteDate: Date
  numberOfHours: number
  chronoBy: string
}

export class ChronoCompleteRequest implements IChronoCompleteRequest {
  public caseLineItemId: number
  public chronoCompleteDate: Date
  public numberOfHours: number
  public chronoBy: string
}
